<template>
  <div class="ml-3">
    <label v-if="label"
           :for="`custom-input-${name}`"><strong>{{ label }}</strong><span class="text-danger">{{ required ? ' *' : '' }}</span></label>
    <div class="d-flex">
      <div v-for="(option, index) of options"
           :key="option.id">
        <div class="d-flex ml-3 mr-3">
          <div class="d-flex align-items-center">
            <svg v-if="option.icon.id"
                 class="radioBox_iconReligioso icon--md  icon"
                 role="presentation">
              <use :xlink:href="'#' + option.icon.id" />
            </svg>
            <label class="pt-2 ml-2"
                   :for="'radioNoLabel' + option.id">{{ option.label }}</label>
            <input
              :id="'radioNoLabel' + option.id"
              v-model="selectedOption"
              class="form-check-input"
              type="radio"
              :name="'radioNoLabel' + option.id"
              :value="option.value"
              @click="(option) => setRegistro(option)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>



  export default {
    name: 'CustomRadioInput',
    props: {
      name: { type: String, required: true },
      options: {type: Array, default: ()=> [], required: true},
      checkedOption: {type: String, default: ''},
      label: {type: [String, null], default: null},
      required: {type: Boolean, default: false},
      formErros: {type: Array, default: null},
    },
    data () {
      return {
        selectedOption: null,
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        if (this.checkedOption) this.selectedOption = this.checkedOption
        if (this.required &&
          !this.checkedOption &&
          this.formErros) {
          this.updateErrorForm(true)
        } // Adiciona o input ao array de erros para validação inicial no componente pai
      },
      setRegistro (value) {
        this.updateErrorForm(false)
        this.$emit('setInputRadio', value.target.value)
      },
      setError (msgError) {
        this.erroState = false // Lida com mensagens de erro e sucesso no input
        if (this.formErros) this.updateErrorForm(true) // add esse input ao array de erro do componente pay 
        if (msgError && !this.customErrorMensage) this.msgError = msgError // Seta a mensagem de acordo a validação
        this.$emit('blur', this.name, null)  // Reinicia o valor do componente pai para evitar erros
      },
      updateErrorForm (add) {
        if (!this.formErros) return
        const arr = this.formErros
        const erroAlredyExist = arr.includes(this.name)
        if (add && !erroAlredyExist) {
          arr.push(this.name)
        } else if (!add && erroAlredyExist) {
          const index = arr.indexOf(this.name)
          arr.splice(index, 1)
        }
        this.$emit('setError', arr)
      },
    }
  }
</script>

<style scoped>
.icon {
  width: 20px;
}
</style>
